import { useState } from "react";

export const useTimeout = () => {
  const [timeoutId, setTimeOutId] = useState<NodeJS.Timeout | null>(null);
  const initializeTimeout = (callback: () => void, delay: number) => {
    const id = setTimeout(callback, delay);
    setTimeOutId(id);
  };
  const killTimeout = () => {
    if (timeoutId) clearTimeout(timeoutId);
  };
  return {
    initializeTimeout,
    killTimeout
  };
};
